import * as yup from 'yup';

import { STRINGS } from '@/constants/strings';
import { emailRule } from '@/validation';

/** Reuse the shared validation copy so guardian forms stay consistent. */
const MESSAGES = STRINGS.mutatePlayer.validation;

/** Optional free-text message attached to the contact request (BR-03). */
export const MAX_CONTACT_MESSAGE_LENGTH = 1000;

/** Max length for the sender's name. */
export const MAX_CONTACT_NAME_LENGTH = 100;

/** Contact Us form — name, email (required, prefilled), question type and an optional message. */
export const guardianContactUsSchema = yup
  .object({
    name: yup.string().trim().required(MESSAGES.fieldRequired).max(MAX_CONTACT_NAME_LENGTH),
    email: emailRule(MESSAGES.fieldRequired, MESSAGES.emailInvalid),
    questionType: yup.string().trim().required(STRINGS.guardian.contactUs.questionTypeRequired),
    message: yup.string().trim().defined().max(MAX_CONTACT_MESSAGE_LENGTH),
  })
  .required();

export type GuardianContactUsForm = {
  name: string;
  email: string;
  questionType: string;
  message: string;
};

export const INITIAL_GUARDIAN_CONTACT_US_FORM: GuardianContactUsForm = {
  name: '',
  email: '',
  questionType: '',
  message: '',
};
